export class Result {

  private constructor(readonly ok: boolean, readonly error?: string) {
  }

  static ok(): Result {
    return new Result(true);
  }

  static error(error: string): Result {
    return new Result(false, error);
  }

}
